/**
 * DndStatsProvider — wraps children in a react-dnd provider configured
 * with the MultiBackend (HTML5 + Touch) so substitution drag-drop works
 * on both desktop and tablets.
 *
 * Same backend setup as the original EstadisticasNew.js (HTML5toTouch).
 */

import React from 'react';
import { DndProvider } from 'react-dnd';
import { MultiBackend, MouseTransition, TouchTransition } from 'react-dnd-multi-backend';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { TouchBackend } from 'react-dnd-touch-backend';

export const ITEM_TYPE_PLAYER = 'PLAYER';

export const PLAYER_SOURCES = {
  BENCH: 'bench',
  FLOOR: 'floor',
};

const HTML5toTouch = {
  backends: [
    {
      id: 'html5',
      backend: HTML5Backend,
      transition: MouseTransition,
    },
    {
      id: 'touch',
      backend: TouchBackend,
      options: { enableMouseEvents: true },
      preview: true,
      transition: TouchTransition,
    },
  ],
};

export default function DndStatsProvider({ children }) {
  return (
    <DndProvider backend={MultiBackend} options={HTML5toTouch}>
      {children}
    </DndProvider>
  );
}
